import MessageApi from '../../../../api/inbox/message';

export default {
  async translateMessage(_, { conversationId, messageId, targetLanguage }) {
    // The caller shows the error, so it is not caught here.
    await MessageApi.translateMessage(
      conversationId,
      messageId,
      targetLanguage
    );
  },
};
